import { createUseStyles } from 'react-jss';

export const UserInfoStyle = createUseStyles({
    userNameStyle: {
        marginLeft: 12,
        color: 'black',
        fontWeight: 'bold',
    },
    emailStyle: {
        marginLeft: 12,
        color: 'black',
    },
    userInfoStyle: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        lineHeight: 1.5,
        paddingTop: 20,
    },
});
